<div *ngIf="!!notationInformation">
    <h2 class="_sansSerif _primary" [i18nKey]="titleLabelKey"></h2>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <div class="grid-y">
    <kiwi-notation-information-mark class="cell shrink notationItem _minimum"
                                    [mark]="notationInformation.minimum"
                                    [maximumMark]="maximumMark"
                                    [labelKey]="minimumLabelKey">
    </kiwi-notation-information-mark>

    <kiwi-notation-information-mark class="cell shrink notationItem _average"
                                    [mark]="notationInformation.average"
                                    [maximumMark]="maximumMark"
                                    [labelKey]="averageLabelKey">
    </kiwi-notation-information-mark>

    <kiwi-notation-information-mark class="cell shrink notationItem _maximum"
                                    [mark]="notationInformation.maximum"
                                    [maximumMark]="maximumMark"
                                    [labelKey]="maximumLabelKey">
    </kiwi-notation-information-mark>
    </div>
</div>
